module.exports = __webpack_public_path__ + "static/avanti-loft-b2fa5553d2d6f8de419c39e819f260b5.png";